function noop() {
}

const ButtonAttrs = {
  tags: "el-button",
  text: "点击上传",
  attrs:{
    icon: "el-icon-upload",
    size: "small",
    type: "primary",
    style:{
      fontSize: "12px"
    }
  }
}

// 自定义属性
export const CustomProps = {
  // 上传样式分类
  model: {
    type: [Object, String],
    default: () => {
      // return ButtonAttrs
      return 'button'
    }
  },

  // 提示说明文字
  tipText:{
    type: String,
    default:""
  }
}

// ElUpload 继承属性
export default {
  ...CustomProps,
  // 必选参数，上传的地址
  action: {type: String, required: true},
  // 设置上传的请求头部
  headers: {type: Object, default() {return {};}},
  // 是否支持多选文件
  multiple: Boolean,
  // 上传时附带的额外参数
  data: Object,
  // 上传的文件字段名
  name: {type: String, default: 'file'},
  // 是否启用拖拽上传
  drag: Boolean,
  // 支持发送 cookie 凭证信息
  withCredentials: Boolean,
  // 是否显示已上传文件列表
  showFileList: {type: Boolean, default: true},
  // 接受上传的文件类型（thumbnail-mode 模式下此参数无效）
  accept: String,
  // 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
  beforeUpload: Function,
  // 删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。
  beforeRemove: Function,
  // 文件列表移除文件时的钩子
  onRemove: {type: Function, default: noop},
  // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
  onChange: {type: Function, default: noop},
  // 点击文件列表中已上传的文件时的钩子
  onPreview: Function,
  // 文件上传成功时的钩子
  onSuccess: {type: Function, default: noop},
  // 文件上传时的钩子
  onProgress: {type: Function, default: noop},
  // 文件上传失败时的钩子
  onError: {type: Function, default: noop},
  // 上传的文件列表, 例如: [{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}]
  fileList: {
    type: Array, default() {
      return []
    }
  },
  // 是否在选取文件后立即进行上传
  autoUpload: {type: Boolean, default: true},
  // 文件列表的类型text,picture,picture-card
  listType: {type: String},
  // 覆盖默认的上传行为，可以自定义上传的实现
  httpRequest: Function,
  // 是否禁用
  disabled: Boolean,
  // 最大允许上传个数
  limit: Number,
  // 文件超出个数限制时的钩子
  onExceed: {type: Function, default: noop}
}
